import React from 'react'

export default function FirstSection() {
  return (
    <section>
      <div >
        <div >
          <img className='fit-image' style={{ width: '100%' }} src='/Images/saas-concept-collage.jpg' alt='banner' />
        </div>
      </div>
    </section>
  )
}
